export default __webpack_public_path__ + "static/media/logo.690d49e0.png";